
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M23 18H21.8L23.59 19.7901C23.83 19.6101 24 19.33 24 19C24 18.4501 23.55 18 23 18ZM3.23 2.28005C2.84 1.89005 2.2 1.89005 1.81 2.28005C1.42 2.67005 1.42 3.30005 1.81 3.69005L2.65 4.55005C2.65 4.55005 1.99 5.12005 1.99 6.02005C2 6.92005 2 16 2 16L2.01 16.01C2.01 17.1 2.89 17.99 3.98 18H1C0.45 18 0 18.4501 0 19C0 19.55 0.45 20 1 20H18.13L20.13 22C20.52 22.39 21.15 22.39 21.54 22C21.93 21.6101 21.93 20.98 21.54 20.59L3.23 2.28005ZM7 15C7.31 13.52 7.94 12.07 9.08 10.95L10.67 12.54C9.13 12.92 7.96 13.71 7 15ZM13 9.13005V8.15005C13 7.71005 13.52 7.49005 13.84 7.78005L15 8.87005L16.61 10.37C16.82 10.57 16.82 10.9 16.61 11.1L15.72 11.93L21.3 17.51C21.73 17.14 22 16.61 22 16V6.00005C22 4.91005 21.11 4.02005 20.02 4.02005H7.8L12.94 9.15005C12.96 9.14005 12.98 9.13005 13 9.13005Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-stop-screen-share`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconStopScreenShare

    ```js
    <b-new-b-icon-stop-screen-share />
    ```
</docs>


